import { CreditLimit } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { createAction, createAsyncActionTypes } from '@mews/framework';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'creditLimits';

export const setCreditLimits = (entities: Array<CreditLimit>) => createAction(CREDIT_LIMITS_LOADED, { entities });

export const [getCreditLimits] = createBaseEntitySelectors<ApplicationState, CreditLimit, typeof NAME>(
    parentSelector,
    NAME
);

export const CREDIT_LIMITS_LOADED = prefix('CREDIT_LIMITS_LOADED');
export const CREDIT_LIMIT_ADDED = prefix('CREDIT_LIMIT_ADDED');
export const [CREDIT_LIMIT_ADD_STARTED, CREDIT_LIMIT_ADD_SUCCEEDED, CREDIT_LIMIT_ADD_FAILED] =
    createAsyncActionTypes(CREDIT_LIMIT_ADDED);
export const CREDIT_LIMIT_UPDATED = prefix('CREDIT_LIMIT_UPDATED');
export const [CREDIT_LIMIT_UPDATE_STARTED, CREDIT_LIMIT_UPDATE_SUCCEEDED, CREDIT_LIMIT_UPDATE_FAILED] =
    createAsyncActionTypes(CREDIT_LIMIT_UPDATED);

export default createEntitiesReducer({
    FETCH_SUCCESS: CREDIT_LIMITS_LOADED,
    ADD_SUCCESS: CREDIT_LIMIT_ADD_SUCCEEDED,
    UPDATE_SUCCESS: CREDIT_LIMIT_UPDATE_SUCCEEDED,
});
